(() => {
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'fr-CA', {
    style: 'currency', currency: window.Shopify?.currency?.active || 'CAD'
  }).format(cents / 100);
  const normalize = (value) => String(value || '').trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  document.querySelectorAll('[data-up-page]').forEach((page) => {
    const form = page.querySelector('[data-up-form]');
    const productBlocks = [...page.querySelectorAll('[data-up-product]')];
    const modelButtons = [...page.querySelectorAll('[data-up-model]')];
    if (!form || !productBlocks.length) return;

    let activeIndex = Math.max(0, modelButtons.findIndex((button) => button.classList.contains('is-active')));
    let activeBlock;
    let variants = [];
    let groups = [];

    const idInput = page.querySelector('[data-up-variant-id]');
    const quantity = page.querySelector('[data-up-quantity]');
    const quantityHidden = page.querySelector('[data-up-quantity-hidden]');
    const price = page.querySelector('[data-up-price]');
    const compare = page.querySelector('[data-up-compare]');
    const submit = page.querySelector('[data-up-submit]');
    const message = page.querySelector('[data-up-message]');
    const title = page.querySelector('[data-up-title]');
    const mockup = page.querySelector('[data-up-mockup]');
    const shirt = page.querySelector('[data-up-shirt]');

    const loadProduct = (index) => {
      activeIndex = index;
      activeBlock = productBlocks.find((block) => Number(block.dataset.upProduct) === index);
      if (!activeBlock) return false;
      productBlocks.forEach((block) => { block.hidden = block !== activeBlock; });
      modelButtons.forEach((button) => {
        const active = Number(button.dataset.upModel) === index;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      groups = [...activeBlock.querySelectorAll('[data-up-option]')];
      try {
        variants = JSON.parse(activeBlock.querySelector('[data-up-product-variants]')?.textContent || '[]');
      } catch (error) {
        console.error(error);
        variants = [];
      }
      const button = modelButtons.find((item) => Number(item.dataset.upModel) === index);
      if (title && button?.dataset.upProductTitle) title.textContent = button.dataset.upProductTitle;
      return true;
    };

    const selections = () => groups.map((group) => group.querySelector('.is-active')?.dataset.upValue || '');
    const currentVariant = () => variants.find((variant) => variant.options.every((value, index) => normalize(value) === normalize(selections()[index])));

    const shirtImage = (value) => {
      if (!mockup) return '';
      const color = normalize(value);
      if (color === 'black' || color === 'noir') return mockup.dataset.upBlack;
      if (color === 'sport grey' || color === 'gris sport') return mockup.dataset.upSportGrey;
      if (['antique sapphire', 'marine saphir', 'navy', 'marine'].includes(color)) return mockup.dataset.upAntiqueSapphire;
      if (['antique irish green', 'irish green', 'vert irlandais'].includes(color)) return mockup.dataset.upAntiqueIrishGreen;
      if (['antique cherry red', 'cherry red', 'rouge cerise', 'rouge'].includes(color)) return mockup.dataset.upAntiqueCherryRed;
      if (['daisy', 'yellow', 'jaune'].includes(color)) return mockup.dataset.upDaisy;
      if (color === 'light pink' || color === 'rose pale') return mockup.dataset.upLightPink;
      return mockup.dataset.upWhite;
    };

    const updateShirt = () => {
      const colorGroup = groups.find((group) => /color|colour|couleur/i.test(group.dataset.upOptionName || ''));
      const src = shirtImage(colorGroup?.querySelector('.is-active')?.dataset.upValue);
      if (!src || !shirt || shirt.src === src) return;
      shirt.classList.add('is-changing');
      const preload = new Image();
      preload.onload = () => { shirt.src = src; shirt.classList.remove('is-changing'); };
      preload.onerror = () => shirt.classList.remove('is-changing');
      preload.src = src;
    };

    const ensureValidSelections = () => {
      groups.forEach((group, index) => {
        const buttons = [...group.querySelectorAll('[data-up-value]')];
        buttons.forEach((button) => {
          const exists = variants.some((variant) => normalize(variant.options[index]) === normalize(button.dataset.upValue));
          button.hidden = !exists;
        });
        if (group.querySelector('.is-active:not([hidden])')) return;
        const first = buttons.find((button) => !button.hidden && variants.some((variant) => variant.available && normalize(variant.options[index]) === normalize(button.dataset.upValue))) || buttons.find((button) => !button.hidden);
        buttons.forEach((button) => {
          const selected = button === first;
          button.classList.toggle('is-active', selected);
          button.setAttribute('aria-pressed', String(selected));
        });
        if (first) group.querySelector('[data-up-selected]')?.replaceChildren(first.dataset.upValue);
      });
    };

    const refresh = () => {
      ensureValidSelections();
      const variant = currentVariant();
      const qty = Math.max(1, Number(quantity.value) || 1);
      quantity.value = qty;
      quantityHidden.value = qty;
      if (variant) {
        idInput.value = variant.id;
        price.textContent = money(variant.price);
        compare.hidden = !(variant.compare_at_price > variant.price);
        if (!compare.hidden) compare.textContent = money(variant.compare_at_price);
      }
      updateShirt();
      const available = Boolean(variant?.available);
      submit.disabled = !available;
      submit.textContent = available ? `Ajouter au panier · ${qty} × ${money(variant.price)} 🛒` : (variant ? 'Rupture de stock' : 'Combinaison non disponible');
      const selected = selections();
      groups.forEach((group, index) => group.querySelectorAll('[data-up-value]').forEach((button) => {
        if (button.hidden) return;
        const candidate = [...selected];
        candidate[index] = button.dataset.upValue;
        button.disabled = !variants.some((item) => item.available && candidate.every((value, i) => !value || normalize(item.options[i]) === normalize(value)));
      }));
    };

    page.querySelectorAll('[data-up-option]').forEach((group) => group.addEventListener('click', (event) => {
      const button = event.target.closest('[data-up-value]');
      if (!button || button.disabled || group.closest('[data-up-product]') !== activeBlock) return;
      group.querySelectorAll('[data-up-value]').forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      group.querySelector('[data-up-selected]')?.replaceChildren(button.dataset.upValue);
      refresh();
    }));

    modelButtons.forEach((button) => button.addEventListener('click', () => {
      if (button.disabled || !loadProduct(Number(button.dataset.upModel))) return;
      message.textContent = '';
      refresh();
    }));

    page.querySelector('[data-up-minus]')?.addEventListener('click', () => { quantity.value = Math.max(1, (Number(quantity.value) || 1) - 1); refresh(); });
    page.querySelector('[data-up-plus]')?.addEventListener('click', () => { quantity.value = (Number(quantity.value) || 1) + 1; refresh(); });
    quantity.addEventListener('change', refresh);

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const variant = currentVariant();
      if (!variant?.available) return;
      const qty = Math.max(1, Number(quantity.value) || 1);
      submit.disabled = true;
      submit.textContent = 'Ajout au panier…';
      message.textContent = '';
      try {
        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: qty }] })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Ajout impossible');
        window.location.assign(window.routes?.cart_url || '/cart');
      } catch (error) {
        message.textContent = error.message;
        refresh();
      }
    });

    if (loadProduct(activeIndex)) refresh();
  });
})();
